import gql from 'graphql-tag';


export const getGalleryImages = gql`
  query {
    galleries(first: 10, orderBy: createdAt_DESC) {
    id
    altTag
    image {
      url
    }
  }
}`;

export const getTestimonials = gql`
  query {
    testimonials(first: 3, orderBy: createdAt_DESC) {
    id
    person
    text
  }
}`;

export const getServices = gql`
  query {
    services(first: 100, orderBy: createdAt_DESC) {
    body
    id
    title
  }
}`;

export const getAllAssets = gql`
  query {
    assets(first: 100, orderBy: createdAt_DESC) {
    id
    url
    fileName
  }
}`;
